<div class="container" (scroll)="getScroll($event)">
  <div class="header" [class.header__postion]="!isHeaderTable">
    <div *ngFor="let item of listHeaders; let i = index" class="tbl-header tbl-{{item.nameClass}}" (click)="actionHeader($event, i)">
      <p class="text-header">{{ item.data }}</p>

      <img src="../../../../assets/svgs/icon_order_down_up.svg" alt="Seta"
        *ngIf="(columnId !== i || countColumn === 0) && item.nameClass !== 'contador' && item.nameClass !== 'desc' && item.nameClass !== 'indicator'">
      
      <img src="../../../../assets/svgs/icon_order_up.svg" alt="Seta para baixo" 
        *ngIf="(columnId === i && countColumn === 1) && item.nameClass !== 'contador' && item.nameClass !== 'desc' && item.nameClass !== 'indicator'">

      <img src="../../../../assets/svgs/icon_order_down.svg" alt="Seta para baixo" 
        *ngIf="(columnId === i && countColumn === 2) && item.nameClass !== 'contador' && item.nameClass !== 'desc' && item.nameClass !== 'indicator'">
    </div>
  </div>

  <div class="table">
    <!-- <div class="tbl-contador tbl">
      <div id="tbl-contador-item-{{i}}" class="tbl-body" [class.tbl-body__center]="data.porcentagem >= 100"
        *ngFor="let data of listTable; let i = index" [ngClass]="{'tbl-hover': id === i}" (mouseover)="hoverEvent(i)">
        <div class="chart-content" *ngIf="data.porcentagem < 100">
          <canvas id="greenChart" baseChart [data]="[data.porcentagem, 100 - data.porcentagem]" [labels]="''"
            [colors]="doughnutChartColorA" [options]="doughnutChartOptions" [chartType]="'doughnut'">
          </canvas>
          <span>{{ data.porcentagem < 10 ? '0' : '' }}{{ data.porcentagem || '0' }}</span>
        </div>
        <img src="../../../../assets/svgs/congratulations.svg" alt="Parabéns" *ngIf="data.porcentagem >= 100">
      </div>
    </div> -->

    <div class="tbl-name tbl">
      <div id="tbl-name-item-{{i}}" class="tbl-body" *ngFor="let data of listTable; let i = index"
        [ngClass]="{'tbl-hover': id === i}" (mouseover)="hoverEvent(i)">
        <p matTooltip="{{data.sku}} {{data.name}}">{{data.sku}}<span *ngIf="data.name"> - {{data.name}}</span></p>
      </div>
    </div>

    <div class="tbl-product tbl">
      <div id="tbl-product-item-{{i}}" class="tbl-body" *ngFor="let data of listTable; let i = index"
        [ngClass]="{'tbl-hover': id === i}" (mouseover)="hoverEvent(i)">
        <div class="market-type">
          <p class="market-type-text">{{data.market_type}}</p>
        </div>
      </div>
    </div>

    <div class="tbl-address tbl">
      <div id="tbl-address-item-{{i}}" class="tbl-body" *ngFor="let data of listTable; let i = index"
        [ngClass]="{'tbl-hover': id === i}" (mouseover)="hoverEvent(i)">
        <p [matTooltip]="data.address.address_summary">{{ data.address.address_summary }}</p>
      </div>
    </div>

    <div class="tbl-stage tbl">
      <div id="tbl-stage-item-{{i}}" class="tbl-body" *ngFor="let data of listTable; let i = index"
        [ngClass]="{'tbl-hover': id === i}" (mouseover)="hoverEvent(i)">
        <p *ngIf="data.property_type" [matTooltip]="data.property_type">{{ data.property_type }}{{ data.property_sub_type && (data.property_type.toLowerCase() !== data.property_sub_type.toLowerCase()) ? "/"+data.property_sub_type : "" }}</p>
      </div>
    </div>

    <div class="tbl-temp tbl">
      <div id="tbl-temp-item-{{i}}" class="tbl-body" *ngFor="let data of listTable; let i = index"
        [ngClass]="{'tbl-hover': id === i}" (mouseover)="hoverEvent(i)">
        <p>{{ data.tower }}</p>
      </div>
    </div>

    <div class="tbl-unit tbl">
      <div id="tbl-unit-item-{{i}}" class="tbl-body" *ngFor="let data of listTable;let i = index"
        [ngClass]="{'tbl-hover': id === i}" (mouseover)="hoverEvent(i)">
        <p>{{ data.unity_number }}</p>
      </div>
    </div>

    <div class="tbl-desc tbl">
      <div id="tbl-desc-item-{{i}}" class="tbl-body" *ngFor="let data of listTable; let i = index"
        [ngClass]="{'tbl-hover': id === i}" (mouseover)="hoverEvent(i)">

        <span *ngFor="let product_value of data.product_values">
          <p *ngIf="productsValuesShowing.includes(product_value.type)"  matTooltip="{{product_value.name}} {{product_value.value}}">
            <img src="../../../../assets/svgs/{{product_value.type}}_fill.svg" alt="{{product_value.name}}">
            <span>{{ product_value.value }}</span>
          </p>
        </span>

      </div>
    </div>

    <div class="tbl-sales tbl">
      <div id="tbl-action-item-{{i}}" class="tbl-body" *ngFor="let data of listTable; let i = index"
        [ngClass]="{'tbl-hover': id === i}" (mouseover)="hoverEvent(i)">
        <p>{{ data.sale_value.currency + data.sale_value.value }}</p>
      </div>
    </div>

    <div class="tbl-rent tbl">
      <div id="tbl-action-item-{{i}}" class="tbl-body" *ngFor="let data of listTable; let i = index"
        [ngClass]="{'tbl-hover': id === i}" (mouseover)="hoverEvent(i)">
        <p><span *ngIf="data.rent_value">{{data.rent_value.currency + data.rent_value.value }}</span></p>
      </div>
    </div>

    <div class="tbl-indicator tbl" *ngIf="false">
      <div id="tbl-indicator-item-{{i}}" class="tbl-body" *ngFor="let data of listTable; let i = index"
        [ngClass]="{'tbl-hover': id === i}" (mouseover)="hoverEvent(i)">
        <p *ngIf="data.indicadores.predio" matTooltip="Empresas">
          <img src="../../../../assets/svgs/predio.svg" alt="Predio">
          <span>{{ data.indicadores.predio }}</span>
        </p>
        <p *ngIf="data.indicadores.estrela" matTooltip="Exclusividade">
          <img src="../../../../assets/svgs/star.svg" alt="Estrelas">
        </p>
        <p *ngIf="data.indicadores.pessoas" matTooltip="Gestão">
          <img src="../../../../assets/svgs/user.svg" alt="Usuário">
        </p>
        <p *ngIf="data.indicadores.diamante" matTooltip="Alto padrão">
          <img src="../../../../assets/svgs/diamond.svg" alt="Diamante">
        </p>
        <p *ngIf="data.indicadores.iconeEstranho" matTooltip="Placa">
          <img src="../../../../assets/svgs/coisa.svg" alt="Coisa">
        </p>
        <p *ngIf="data.indicadores.calendario" matTooltip="Plantão">
          <img src="../../../../assets/svgs/calender.svg" alt="Calendario">
        </p>
        <p *ngIf="data.indicadores.dinheiro" matTooltip="Proposta">
          <img src="../../../../assets/svgs/money.svg" alt="Dinheiro">
        </p>
      </div>
    </div>

    <div class="tbl-hover-action tbl" *ngIf="false">
      <div class="tbl-body" id="tbl-hover-action-{{i}}" *ngFor="let data of listTable; let i = index"
        [ngClass]="{'tbl-hover': id === i, 'is-hover': id !== i}" (mouseover)="hoverEvent(i)">
        <div class="btn-hover" *ngIf="id === i">
          <button class="btn-action" (click)="actionTable()" [matMenuTriggerFor]="beforeMenu">
            <img src="../../../../assets/svgs/i_btn_hover_table.svg" alt="Actions">
          </button>
          <mat-menu #beforeMenu="matMenu" xPosition="before">
            <button mat-menu-item>Editar</button>
            <button mat-menu-item>Excluir</button>
          </mat-menu>
        </div>
      </div>
    </div>

  </div>
</div>